import { DigitisationStatus } from '®shared/list-item/digitisation/digitised-content';
import { EditableItem } from '®shared/reading-list/models';
import { CourseReserveFilterStatus } from '®shared/reading-list/quick-filters/course-reserve-status-filter-and-label';
import { DigitisationFilterStatus } from '®shared/reading-list/quick-filters/digitisation-status-filter-and-label';

export function getDigitisationStatusFilterForItem(
  item: EditableItem,
): DigitisationFilterStatus {
  const itemDigitisationStatus = item.content && item.content.status;

  switch (itemDigitisationStatus) {
    case DigitisationStatus.LIVE: {
      return DigitisationFilterStatus.DIGITISED;
    }
    case DigitisationStatus.PENDING:
    case DigitisationStatus.REFERRED: {
      return DigitisationFilterStatus.DIGITISATION_PENDING;
    }
    default: {
      return DigitisationFilterStatus.NO_DIGITISATION;
    }
  }
}

export function getCourseReserveStatusFilterForItem(
  item: EditableItem,
): CourseReserveFilterStatus {
  const itemCourseReserveStatus = item.content && item.content.status;

  switch (itemCourseReserveStatus) {
    case DigitisationStatus.LIVE: {
      return CourseReserveFilterStatus.COURSE_RESERVE;
    }
    default: {
      return null;
    }
  }
}
